<!-- <p>company works!</p> -->
<div class="main-outer company-list admin-customer-subscription">
    <app-header></app-header>
    <div class="municipality-accounts" [ngClass]="Menustatus ? 'show' : ''">
        <div class="municipality-accounts__sidebar doc-cabinet-menu-left">
            <h2 class="heading-secondery">Admin</h2>

            <ul class="dc-menu-list">
                <li class="dc-menu-item">
                    <a href="javascript:void(0);" routerLink="/company" routerLinkActive="active">Company</a>
                </li>
                <li class="dc-menu-item">
                    <a href="javascript:void(0);" routerLink="/subscriptions"
                        routerLinkActive="active">Subscriptions</a>
                </li>
                <li class="dc-menu-item">
                    <a href="javascript:void(0);" routerLink="/batches" routerLinkActive="active">Batches</a>
                </li>
            </ul>

            <a href="javascript:void(0);" class="sidebar-menu" (click)="showMenu()">
                <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0 1.40476C0 1.07008 0.132951 0.749111 0.369604 0.512457C0.606258 0.275804 0.927229 0.142853 1.26191 0.142853H16.4048C16.7395 0.142853 17.0605 0.275804 17.2971 0.512457C17.5338 0.749111 17.6667 1.07008 17.6667 1.40476C17.6667 1.73944 17.5338 2.06041 17.2971 2.29706C17.0605 2.53372 16.7395 2.66667 16.4048 2.66667H1.26191C0.927229 2.66667 0.606258 2.53372 0.369604 2.29706C0.132951 2.06041 0 1.73944 0 1.40476Z"
                        fill="white" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M7.57144 7.7143C7.57144 7.37962 7.70439 7.05865 7.94105 6.822C8.1777 6.58534 8.49867 6.45239 8.83335 6.45239H16.4048C16.7395 6.45239 17.0604 6.58534 17.2971 6.822C17.5338 7.05865 17.6667 7.37962 17.6667 7.7143C17.6667 8.04898 17.5338 8.36995 17.2971 8.6066C17.0604 8.84326 16.7395 8.97621 16.4048 8.97621H8.83335C8.49867 8.97621 8.1777 8.84326 7.94105 8.6066C7.70439 8.36995 7.57144 8.04898 7.57144 7.7143Z"
                        fill="white" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0 14.0238C0 13.6892 0.132951 13.3682 0.369604 13.1315C0.606258 12.8949 0.927229 12.7619 1.26191 12.7619H16.4048C16.7395 12.7619 17.0605 12.8949 17.2971 13.1315C17.5338 13.3682 17.6667 13.6892 17.6667 14.0238C17.6667 14.3585 17.5338 14.6795 17.2971 14.9161C17.0605 15.1528 16.7395 15.2857 16.4048 15.2857H1.26191C0.927229 15.2857 0.606258 15.1528 0.369604 14.9161C0.132951 14.6795 0 14.3585 0 14.0238Z"
                        fill="white" />
                </svg>
            </a>
        </div>


        <div class="container">
            <div class="page-wrapper" [ngClass]="filterResposniveEvent ? 'active-sidebar' : ''">

                <div class="page-filter" *ngIf="!isCustomerAdmin">
                    <div class="page-filter-inner">
                        <div class="">
                            <a class="close-popup close-popup-filter" href="javascript:void(0);"
                                (click)="filterClickEvent()">
                                <svg width="19" height="19" viewBox="0 0 19 19" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.3104 1.67919L1.49018 17.4995" stroke="#4E4E4E" stroke-width="2" />
                                    <line x1="1.77569" y1="1.3107" x2="17.4143" y2="17.7099" stroke="#4E4E4E"
                                        stroke-width="2" />
                                </svg>
                            </a>
                            <h2>Filters</h2>

                            <div class="select-menu filter-group">
                                <label class="filter-lbl">Customer</label>
                                <p-dropdown class="select-dropdown" [options]="customerOptions" optionLabel="label"
                                    optionValue="value" [(ngModel)]="selectedCustomerId" [filter]="true"
                                    [showClear]="true" placeholder="Select"></p-dropdown>
                            </div>

                            <div class="select-menu filter-group">
                                <label class="filter-lbl">Batch date from</label>
                                <p-calendar appendTo="body" [(ngModel)]="fromDate"
                                    panelStyleClass="body-calendar" inputId="fromDate"
                                    class="form__calendar" [showIcon]="true" placeholder="Calendar">
                                </p-calendar>
                            </div>

                            <div class="select-menu filter-group">
                                <label class="filter-lbl">Batch date to</label>
                                <p-calendar appendTo="body" [(ngModel)]="toDate" [minDate]="fromDate"
                                    panelStyleClass="body-calendar" inputId="toDate"
                                    class="form__calendar" [showIcon]="true" placeholder="Calendar">
                                </p-calendar>
                            </div>

                            <div class="form-button-group">
                                <a class="btn-primary common-btn" (click)="applyFilters()">Apply</a>
                                <a [ngClass]="showClearFilter ? '' : 'active'" *ngIf="displayClearButton"
                                    class="btn-secondary" (click)="resetFilter()">Clear</a>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="page-wrapper-listing">

                    <div class="title-block">
                        <div class="title-block__left">
                           <h1>Batches</h1>
                            <p>Received automatically from the Capture/Imaging system after QA processing. Read-only.</p>
                        </div>
                        
                        <div class="responsive-filter">
                            <a href="javascript:void(0);" class="mobile-block" (click)="filterClickEvent()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20">
                                    <path fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round"
                                        stroke-linejoin="round" stroke-width="2" d="M20 0H0l8 9.46V16l4 2V9.46z"
                                        transform="translate(1 1)" />
                                </svg>
                            </a>
                            <div class="search-box search-component">
                                <input type="text" #searchBox class="search-box__input" placeholder="Search batch ID or customer"
                                    [ngModel]="searchText" (ngModelChange)="onSearchChange($event)" />
                                <a href="javascript:void(0);" class="search-box__btns"><svg width="15" height="15"
                                        viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M6.41471 12.8287C7.83796 12.8284 9.22019 12.352 10.3413 11.4753L13.8662 15L15 13.8663L11.4751 10.3416C12.3523 9.22039 12.8291 7.83791 12.8294 6.41437C12.8294 2.87765 9.95162 0 6.41471 0C2.8778 0 0 2.87765 0 6.41437C0 9.95109 2.8778 12.8287 6.41471 12.8287ZM6.41471 1.60359C9.068 1.60359 11.2257 3.76123 11.2257 6.41437C11.2257 9.06751 9.068 11.2251 6.41471 11.2251C3.76143 11.2251 1.60368 9.06751 1.60368 6.41437C1.60368 3.76123 3.76143 1.60359 6.41471 1.60359Z"
                                            fill="#434343" />
                                    </svg>
                                </a>
                            </div>

                            <div class="customer-sum" *ngIf="batches?.length > 0">({{batches?.length}}
                                of {{totalRecords}} Batches)</div>
                        </div>
                    </div>

                    <div class="document-cabinet-list customers-list company-table">
                        <div class="column-frozen-table">
                            <p-table [value]="batches" class="tables-frozen customers-list-table"
                                [rows]="pageSize" [virtualScroll]="true" [scrollable]="true"
                                [lazy]="true" [lazyLoadOnInit]="false" [totalRecords]="totalRecords"
                                (onLazyLoad)="onLazyLoad($event)" scrollHeight="500px">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th pSortableColumn="BatchId">Batch ID <span class="sorting-icon"></span></th>
                                        <!-- <th>Customer ID</th> -->
                                        <th pSortableColumn="CustomerName">Company <span class="sorting-icon"></span></th>
                                        <th pSortableColumn="BatchDate">Batch Date <span class="sorting-icon"></span></th>
                                        <th pSortableColumn="JobName">Job Name <span class="sorting-icon"></span></th>
                                        <th pSortableColumn="TotalDocuments">Total Documents <span class="sorting-icon"></span></th>
                                        <th pSortableColumn="TotalPages">Total Pages <span class="sorting-icon"></span></th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-batch>
                                    <tr>
                                        <td><strong style="font-weight: 700; color: #1f2937;">{{ formatBatchId(batch.BatchId) }}</strong></td>
                                        <!-- <td>{{ batch.CustomerId }}</td> -->
                                        <td>{{ getCompanyName(batch) }}</td>
                                        <td>{{ batch.BatchDate | date:'MMM d, y' }}</td>
                                        <td>{{ batch.JobName }}</td>
                                        <td>{{ batch.TotalDocuments | number }}</td>
                                        <td>{{ batch.TotalPages | number }}</td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td [attr.colspan]="7" class="text-center">No records found</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<div class="alert" [ngClass]="messageClass ? 'success' : 'warning'" *ngIf="displayMessage">
    <p>{{message}}</p>
    <a class="close-popup" href="javascript:void(0);" (click)="closeMessagePopup()"><img width="20"
            src="assets/img/close-ic.svg"> </a>
</div>

<div class="loader-outer" *ngIf="loading">
    <div class="loader"></div>
</div>


